import { Box, Typography } from '@mui/material'
import { FC } from 'react'

interface CustomChipProps {
    text: string;
}

export const CustomChip: FC<CustomChipProps> = ({ text }) => {
  return (
    <Box className="border border-sky-400 rounded-full bg-sky-50 py-1 px-2">
        <Typography className="text-xs font-semibold text-sky-700">{text}</Typography>
    </Box>
  )
}
